export default __webpack_public_path__ + "static/media/polk_usdc.47d63e75.png";